import { RoomList } from './RoomList'
import { RoomCreate } from './RoomCreate'
import { RoomEdit } from './RoomEdit'
import { RoomShow } from './RoomShow'

export { RoomList, RoomCreate, RoomEdit, RoomShow }


// WEBPACK FOOTER //
// ./src/components/room/index.js